import { DistanceInputFilter } from "domain/models/distance-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { Distance } from "domain/entities/distance";
import { IDistanceRepository } from "domain/contracts/distance";

class DistanceRepository implements IDistanceRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/distance/${id}`);
    return response.data;
  }

  async create(input: Partial<Distance>): Promise<Message<Distance>> {
    const response = await httpClient.post(`/distance`, { data: input });
    return response.data;
  }

  async update(input: Partial<Distance>): Promise<Message<boolean>> {
    const response = await httpClient.put(`/distance/${input.id}`, {
      data: input,
    });
    return response.data;
  }
  
   async getById(id: string): Promise<Message<Distance>> {
    const response = await httpClient.get(`/distance/${id}`);
    return response.data;
  }

  async getAll(filter: DistanceInputFilter): Promise<Message<Distance[]>> {
    const response = await httpClient.get(`/distance`, { params: filter });
    return response.data;
  }

  async populate(): Promise<Message<boolean>> {
    const response = await httpClient.post(`/distance/populate`);
    return response.data;
  }
}

export default new DistanceRepository();
